{
  "CHAT_LIST": {
    "LOADING": "Dohvaćanje razgovora",
    "LOAD_MORE_CONVERSATIONS": "Učitaj još razgovora",
    "EOF": "Svi razgovori su učitani 🎉",
    "LIST": {
      "404": "U ovoj grupi nema aktivnih razgovora."
    },
    "FAILED_TO_SEND": "Slanje nije uspjelo",
    "TAB_HEADING": "Razgovori",
    "MENTION_HEADING": "Spominjanja",
    "UNATTENDED_HEADING": "Neobrađeni",
    "SEARCH": {
      "INPUT": "Pretražite osobe, razgovore, spremljene odgovore..."
    },
    "SEARCH_MESSAGES": "Pretraži razgovore",
    "SEARCH_INPUT_PLACEHOLDER": "Pretraži razgovore...",
    "FILTER_ALL": "Sve",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Moji",
      "unassigned": "Nedodijeljeni",
      "all": "Sve"
    },
    "MESSAGE_USE_AS_TEMPLATE": "Zalijepi u odgovor",
    "CARDS": {
      "ACTIONS": {
        "OPEN": "Otvori",
        "BUY": "Kupi"
      }
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Otvoreni"
      },
      "resolved": {
        "TEXT": "Riješeni"
      },
      "pending": {
        "TEXT": "Na čekanju"
      },
      "snoozed": {
        "TEXT": "Odgođeni"
      },
      "all": {
        "TEXT": "Sve"
      }
    },
    "VIEW_FILTER": "Pregled",
    "SORT_TOOLTIP_LABEL": "Poredaj razgovore",
    "CHAT_SORT": {
      "STATUS": "Status",
      "ORDER_BY": "Poredaj po"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": "Izrađeno",
      "LAST_ACTIVITY": "Zadnja aktivnost:",
      "LAST_CUSTOMER_MESSAGE": "Zadnja poruka korisnika:"
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Zadnja aktivnost: Najstarije prvo"
      },
      "last_activity_at_desc": {
        "TEXT": "Zadnja aktivnost: Najnovije prvo"
      },
      "last_customer_message_at_asc": {
        "TEXT": "Zadnja poruka korisnika: Najstarije prvo"
      },
      "last_customer_message_at_desc": {
        "TEXT": "Zadnja poruka korisnika: Najnovije prvo"
      },
      "created_at_desc": {
        "TEXT": "Kreirano: Najnovije prvo"
      },
      "created_at_asc": {
        "TEXT": "Kreirano: Najstarije prvo"
      },
      "priority_desc": {
        "TEXT": "Prioritet: Najviši prvo"
      },
      "priority_asc": {
        "TEXT": "Prioritet: Najniži prvo"
      },
      "priority_created_at_desc": {
        "TEXT": "Prioritet + Kreirano: Najnovije prvo"
      },
      "priority_created_at_asc": {
        "TEXT": "Prioritet + Kreirano: Najstarije prvo"
      },
      "waiting_since_asc": {
        "TEXT": "Čeka odgovor: Najduže prvo"
      },
      "waiting_since_desc": {
        "TEXT": "Čeka odgovor: Najkraće prvo"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Slikovna poruka"
      },
      "audio": {
        "CONTENT": "Zvučna poruka"
      },
      "video": {
        "CONTENT": "Video poruka"
      },
      "file": {
        "CONTENT": "Privitak"
      },
      "location": {
        "CONTENT": "Lokacija"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "je podijelio poveznicu"
      },
      "contact": {
        "CONTENT": "Podijeljeni kontakt"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Poredaj razgovor",
      "DROPDOWN_TITLE": "Poredaj po",
      "ITEMS": {
        "LATEST": {
          "NAME": "Zadnja aktivnost",
          "LABEL": "Zadnja aktivnost"
        },
        "CREATED_AT": {
          "NAME": "Kreirano",
          "LABEL": "Kreirano"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Zadnja poruka korisnika",
          "LABEL": "Zadnja poruka"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Primljeno e-poštom",
    "VIEW_TWEET_IN_TWITTER": "Prikaži tweet na Twitteru",
    "REPLY_TO_TWEET": "Odgovori na ovaj tweet",
    "LINK_TO_STORY": "Idi na Instagram priču",
    "SENT": "Uspješno poslano",
    "READ": "Pročitano",
    "DELIVERED": "Uspješno isporučeno",
    "NO_MESSAGES": "Nema poruka",
    "NO_CONTENT": "Nema dostupnog sadržaja",
    "HIDE_QUOTED_TEXT": "Sakrij citirani tekst",
    "SHOW_QUOTED_TEXT": "Prikaži citirani tekst",
    "HIDE_AUTOMATED_MESSAGE": "Sakrij sadržaj automatskog odgovora",
    "SHOW_AUTOMATED_MESSAGE": "Prikaži sadržaj automatskog odgovora",
    "AUTOMATED_MESSAGE": "Automatski odgovor",
    "MESSAGE_READ": "Pročitano",
    "SENDING": "Slanje"
  }
}
